export default __webpack_public_path__ + "static/media/lehhome.81066f1a.jpg";